module.exports = __webpack_public_path__ + "img/e6aa11d4b5673d932c9bb2b7d0106879.2be086df.png";